var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end sm:pt-20 z-50",
    },
    _vm._l(_vm.notifications, function (notification, index) {
      return _c("toast-notification", {
        key: index,
        attrs: { notification: notification },
        on: {
          destroy: function ($event) {
            return _vm.removeNotification(index)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }